import { render, staticRenderFns } from "./ActivityTopAuthors.vue?vue&type=template&id=5a6997f9&"
import script from "./ActivityTopAuthors.vue?vue&type=script&lang=js&"
export * from "./ActivityTopAuthors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a6997f9')) {
      api.createRecord('5a6997f9', component.options)
    } else {
      api.reload('5a6997f9', component.options)
    }
    module.hot.accept("./ActivityTopAuthors.vue?vue&type=template&id=5a6997f9&", function () {
      api.rerender('5a6997f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web_src/js/components/ActivityTopAuthors.vue"
export default component.exports